'use client'

import s from './Filter.module.scss'
import { useContext, useCallback } from 'react'
import { WebContext } from '@/context/webContext'
import { AnimatePresence, motion } from 'framer-motion'

type Props = {
  data: any[]
  isOpen: boolean
  onToggle: () => void
  onClose?: () => void
}

export default function FilterComponent({ data, isOpen, onToggle, onClose }: Props) {
  const { categoriesSelected, setCategoriesSelected } = useContext(WebContext)

  const isActive = useCallback(
    (title: string) => (categoriesSelected || []).includes(title),
    [categoriesSelected]
  )

  const toggleCategory = (title: string) => {
    setCategoriesSelected((prev: string[] = []) =>
      prev.includes(title) ? prev.filter(t => t !== title) : [...prev, title]
    )
  }

  const viewAll = () => setCategoriesSelected([])

  return (
    <section className={s.filter}>
      {/* Header del filter */}
      <button
        type="button"
        className={s.logo}
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <span>Filter by</span>
        <span className={`${s.arrow} ${isOpen ? s.arrowOpen : ''}`}>+</span>
      </button>

      {/* Contenido (lo anima el padre) */}
      <AnimatePresence initial={false}>
      {isOpen && (
        <motion.nav
        className={s.nav}
        initial={{ height: 0 }}
        animate={{ height: 'auto' }}
        exit={{ height: 0 }}
        transition={{ duration: 0.3, ease: 'easeOut' }}
        style={{ overflow: 'hidden' }}>
          <ul className={s.menu}>
            {data?.map((item: any, i: number) => {
              const active = isActive(item.title)
              return (
                <li
                  key={i}
                  className={`${s.menuItem} ${active ? s.active : ''}`}
                  onClick={() => toggleCategory(item.title)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === 'Enter' && toggleCategory(item.title)}
                >
                  {item.title}
                </li>
              )
            })}
          </ul>

          <button
            type="button"
            className={`${s.buttonAll} ${(categoriesSelected || []).length === 0 ? s.activeAll : ''}`}
            onClick={viewAll}
          >
            View all
          </button>
        </motion.nav>
      )}
      </AnimatePresence>
    </section>
  )
}